export default __webpack_public_path__ + "static/media/self.e6ba6e45.jpg";